<template>
  <validation-observer #default="{ handleSubmit }" ref="personalForm">
    <form @submit.prevent="handleSubmit(() => onCreateOrUpdate())">
      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <validation-provider #default="{ errors }" name="First Name" rules="required">
            <b-form-group label="First Name" label-for="first_name">
              <template #label>
                <span>First Name<sup style="color: tomato">*</sup></span>
              </template>

              <b-form-input id="first_name" v-model="memberProfile.first_name" placeholder="John"
                :disabled="disableForm"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider #default="{ errors }" name="Last Name" rules="required">
            <b-form-group label="Last Name" label-for="last_name">
              <template #label>
                <span>Last Name<sup style="color: tomato">*</sup></span>
              </template>

              <b-form-input id="last_name" v-model="memberProfile.last_name" placeholder="Doe"
                :disabled="disableForm"
/>

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <validation-provider #default="{ errors }" name="Date of Birth" rules="required">
            <b-form-group label="Date of Birth" label-for="last_name">
              <template #label>
                <span>Date of Birth<sup style="color: tomato">*</sup></span>
              </template>

              <cleave v-model="memberProfile.date_of_birth" :raw="false" :options="cleaveDateOptions" autocomplete="off"
                class="form-control" name="date of birth" placeholder="YYYY-MM-DD"
/>

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider #default="{ errors }" name="Gender" rules="required">
            <b-form-group label="Gender" label-for="gender">
              <template #label>
                <span>Gender<sup style="color: tomato">*</sup></span>
              </template>

              <v-select id="gender" placeholder="Gender" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :value="memberProfile.gender" :options="genderOptions" :reduce="(val) => val.value" :disabled="loading"
                @input="(val) => (memberProfile.gender = val)"
/>

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <validation-provider #default="{ errors }" name="Country" rules="required">
            <b-form-group label="Country" label-for="country">
              <template #label>
                <span>Country<sup style="color: tomato">*</sup></span>
              </template>

              <v-select class="country" placeholder="Country" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :value="memberProfile.country" :options="countryOptions" :reduce="(val) => val.value" :clearable="false"
                :disabled="loading" @input="(val) => (memberProfile.country = val)"
/>

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <validation-provider #default="{ errors }" name="Hometown" rules="">
            <b-form-group label="Hometown" label-for="hometown">
              <template #label>
                <span>Hometown</span>
              </template>

              <b-form-input id="hometown" v-model="memberProfile.home_town" placeholder="Hometown"
                :disabled="disableForm"
/>

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider #default="{ errors }" name="Profession" rules="">
            <b-form-group label="Profession" label-for="profession">
              <template #label>
                <span>Profession</span>
              </template>

              <b-form-input id="profession" v-model="memberProfile.profession" placeholder="Profession"
                :disabled="disableForm"
/>

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <validation-provider #default="{ errors }" name="Languages Spoken" rules="">
            <b-form-group label="Languages Spoken" label-for="languages_spoken">
              <template #label>
                <span>Languages Spoken</span>
              </template>

              <b-form-input id="languages_spoken" v-model="memberProfile.languages_spoken"
                placeholder="Languages spoken" :disabled="disableForm"
/>

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider #default="{ errors }" name="Qualifications" rules="">
            <b-form-group label="Qualifications" label-for="qualifications">
              <template #label>
                <span>Qualifications</span>
              </template>

              <b-form-textarea id="qualifications" v-model="memberProfile.qualifications" placeholder="Qualifications"
                rows="3" :disabled="disableForm"
/>

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="lg" class="mr-2 mb-5"
        :disabled="disableForm" type="submit"
>
        Save
      </b-button>
    </form>
  </validation-observer>
</template>

<script>
import { get } from "lodash";
import Cleave from "vue-cleave-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BOverlay,
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAvatar,
  BFormTextarea,
  BFormInvalidFeedback,
  BButton,
  BFormFile,
  BFormCheckbox,
  BAlert,
  BCardText,
  BModal,
  BMedia,
  BMediaBody,
  BMediaAside,
  BImg,
  BTabs,
  BTab,
  BCard,
  BFormDatepicker
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

export default {
  name: "MemberUpdatePersonalData",
  components: {
    vSelect,
    Cleave,
    BOverlay,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAvatar,
    BFormTextarea,
    BFormInvalidFeedback,
    BButton,
    BFormFile,
    BFormCheckbox,
    BAlert,
    BCardText,
    BModal,
    BMedia,
    BMediaBody,
    BMediaAside,
    BImg,
    BTabs,
    BTab,
    BCard,
    BFormDatepicker,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    initialValues: {
      type: Object,
      default: () => { },
    },
    disableForm: {
      type: Boolean,
      default: false,
    },
    countryOptions: {
      type: Array,
      default: () => [],
    },
    genderOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      memberProfile: {
        gender: "",
        first_name: "",
        last_name: "",
        date_of_birth: "",
        country: "",
        home_town: "",
        profession: "",
        languages_spoken: "",
        qualifications: ""
      },
      cleaveDateOptions: {
        date: true,
        raw: true,
        delimiter: "-",
        datePattern: ["Y", "m", "d"],
        blocks: [4, 2, 2],
      },
    }
  },
  mounted() {
    this.memberProfile = { ...this.initialValues };
  },
  methods: {
    async onCreateOrUpdate(form_to_validate) {
      try {
        if (form_to_validate) {
          const success = await this.$refs.personalForm.validate();
          if (!success) {
            this.toast({
              title: "Error!",
              icon: "AlertQuestionIcon",
              variant: "warning",
              text: `Member updated successfully`,
            });
            return;
          }
        }
        this.loading = true;
        this.errorMessage = "";

        const messages = {
          update: {
            title: "Confirm Member Update",
            text: "Do you want to update this member?",
            icon: "warning",
          },
        };

        /* eslint-disable no-nested-ternary */
        const message = messages.update;
        const { title, text, icon } = message;

        const result = await this.$swal({
          title,
          text,
          icon,
          showCancelButton: true,
          confirmButtonText: "Yes, proceed.",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        });
        if (!result.isConfirmed) {
          return;
        }

        this.sanitizeObjectIds(this.memberProfile);

        await this.useJwt().mainService.memberProfiles.updatePersonal(this.$route.params.id, this.memberProfile);

        this.$emit("refetchData");
        this.$emit("update:is-add-or-update-active", false);

        this.toast({
          title: "Success!",
          icon: "AlertQuestionIcon",
          variant: "success",
          text: `Member updated successfully`,
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message;
        this.errorMessage = error_message;

        this.toast({
          title: "Success!",
          icon: "AlertQuestionIcon",
          variant: "success",
          text: `Member updated successfully`,
        });
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>

<style></style>
